import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { settingsNavPathV3 } from "@/react/helpers/urlHelpers";
import { useBackendProps } from "@circle-react/providers";
import { useRouteHelpers } from "@circle-react/routes/Main/useRouteHelpers";
import type { CommunitySwitcherContentV3Props } from "./CommunitySwitcherContentV3";
import { CommunitySwitcherContentV3 } from "./CommunitySwitcherContentV3";

export const CommunitySwitcher = (props: CommunitySwitcherContentV3Props) => {
  const { pathname } = useLocation();
  const { isSettingsPage, isLivePage } = useRouteHelpers();
  const is2faPage = pathname.startsWith("/two_fa");
  const isPlansPage = pathname.startsWith(settingsNavPathV3.plans.general);
  const { display_community_switcher: isDisplayCommunitySwitcherEnabled } =
    useBackendProps();

  const { currentCommunity } = usePunditUserContext();
  const isSubscriptionCancelled = currentCommunity?.subscription_cancelled;
  const shouldDisplayCommunitySwitcherOnPlansPage =
    isSubscriptionCancelled && isPlansPage;

  // Allow community switcher on plans page even though it's a settings page
  const shouldHideCommunitySwitcherOnSettingsPage =
    isSettingsPage && !shouldDisplayCommunitySwitcherOnPlansPage;

  const shouldHideCommunitySwitcher =
    shouldHideCommunitySwitcherOnSettingsPage || is2faPage || isLivePage;

  useEffect(() => {
    if (shouldHideCommunitySwitcherOnSettingsPage) {
      document.body.classList.remove("has-community-switcher");
    } else if (isDisplayCommunitySwitcherEnabled) {
      document.body.classList.add("has-community-switcher");
    }
  }, [
    pathname,
    shouldHideCommunitySwitcherOnSettingsPage,
    isDisplayCommunitySwitcherEnabled,
    shouldDisplayCommunitySwitcherOnPlansPage,
  ]);

  if (shouldHideCommunitySwitcher) {
    return null;
  }

  return <CommunitySwitcherContentV3 {...props} />;
};
